import { doApi } from './apiClient';

export interface AppSetting {
  key: string;
  value: string;
  description: string;
}

export interface AppSettingHistoryEntry {
  old_value: string;
  new_value: string;
  changed_at: string;
  changed_by: {
    id: number;
    username: string;
    nickname_forum: string | null;
  };
}

export const apiGetAppSettings = (): Promise<{ data: AppSetting[] }> =>
  doApi<{ data: AppSetting[] }>('api/admin/app-settings', 'GET');

export const apiUpdateAppSetting = (key: string, value: string): Promise<{ data: AppSetting }> =>
  doApi<{ data: AppSetting }>(`api/admin/app-settings/${key}`, 'PATCH', { value });

export const apiGetAppSettingHistory = (key: string): Promise<{ data: AppSettingHistoryEntry[] }> =>
  doApi<{ data: AppSettingHistoryEntry[] }>(`api/admin/app-settings/${key}/history`, 'GET');
